import React from 'react';
import SignInForm from './SignInForm';
import { CreditCard, Shield, BarChart3 } from 'lucide-react';
import './AuthPage.css';

const AuthPage: React.FC = () => {
  return (
    <div className="auth-page">
      <div className="auth-container">
        {/* Left side - Company info */}
        <div className="company-info">
          <div className="logo">
            <img src="/esn.png" alt="ESN Logo" className="logo-image" style={{ height: '48px', objectFit: 'contain' }} />
          </div>

          <h1>Fuel Card Admin Panel</h1>
          <p className="subtitle">Energy Smart NG</p>
          <p className="description">
            Comprehensive fuel card management platform for corporate accounts,
            transaction monitoring, and business analytics.
          </p>

          <div className="features">
            <div className="feature-item">
              <div className="feature-icon">
                <CreditCard size={24} />
              </div>
              <span>Card Management</span>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <Shield size={24} />
              </div>
              <span>Fraud Detection</span>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <BarChart3 size={24} />
              </div>
              <span>Company Analytics</span>
            </div>
          </div>
        </div>

        {/* Right side - Auth form */}
        <div className="auth-forms">
          <div className="form-container">
            <div className="form-header">
              <h2>Welcome</h2>
              <p>Access your fuel card management dashboard</p>
            </div>

            <div className="form-content">
              <SignInForm />
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
